const quizReducer = (state, action) => {
  switch (action.type) {
    // Common action to load backend quiz data.
    case "LOAD_QUIZ":
      return { ...state, ...action.payload };

    /* 
      New actions for the Guess By Emoji quiz.
      These actions are used to update fields that exist in the Guess By Emoji schema.
    */
    case "UPDATE_TITLE":
      return {
        ...state,
        title: action.payload.text,
      };
    case "SET_THUMBNAIL_INDEX":
      return {
        ...state,
        thumb_index: action.payload.index,
      };
    case "UPDATE_INTRO_VOICE_TEXT":
      return {
        ...state,
        introvoice: {
          ...state.introvoice,
          text: action.payload.text,
        },
      };

    case "UPDATE_ITEM_VOICE_TEXT":
      return {
        ...state,
        items: state.items.map((item, i) =>
          i === action.payload.index
            ? { ...item, voice: { ...item.voice, text: action.payload.text } }
            : item
        ),
      };

    case "UPDATE_ITEM_ANSWER_TEXT":
      return {
        ...state,
        items: state.items.map((item, i) =>
          i === action.payload.index
            ? { ...item, answer: { ...item.answer, text: action.payload.text } }
            : item
        ),
      };

    case "UPDATE_ITEM_NAME_TEXT":
      return {
        ...state,
        items: state.items.map((item, i) =>
          i === action.payload.index
            ? { ...item, name: { ...item.name, text: action.payload.text } }
            : item
        ),
      };

    case "UPDATE_ITEM_EMOJIS":
      return {
        ...state,
        items: state.items.map((item, i) =>
          i === action.payload.index ? { ...item, emojis: action.payload.emojis } : item
        ),
      };

    /* 
      Existing actions for other quiz types.
      These cases remain available for any quiz that needs them.
    */
    case "UPDATE_ITEM":
      return {
        ...state,
        items: state.items.map((item, i) =>
          i === action.payload.index ? { ...item, ...action.payload.newData } : item
        ),
      };

    case "UPDATE_OPTION":
      return {
        ...state,
        items: state.items.map((item, i) => {
          if (i !== action.index) return item;
          if (action.optionKey) {
            return {
              ...item,
              [action.optionKey]: {
                ...item[action.optionKey],
                [action.field]: action.value,
              },
            };
          } else {
            return {
              ...item,
              [action.field]: action.value,
            };
          }
        }),
      };

    case "UPDATE_IMAGES":
      return {
        ...state,
        items: state.items.map((item, i) =>
          i === action.payload.index
            ? {
                ...item,
                [action.payload.optionKey]: {
                  ...item[action.payload.optionKey],
                  images: [
                    ...(item[action.payload.optionKey].images || []),
                    ...action.payload.images,
                  ],
                },
              }
            : item
        ),
      };

    case "UPDATE_SELECTION":
      return {
        ...state,
        items: state.items.map((item, i) =>
          i === action.payload.index
            ? {
                ...item,
                [action.payload.optionKey]: {
                  ...item[action.payload.optionKey],
                  selection: action.payload.image,
                },
              }
            : item
        ),
      };

    case "UPDATE_VOICEOVER_CHARACTER":
      return {
        ...state,
        items: state.items.map((item, i) =>
          i === action.payload.index
            ? {
                ...item,
                character: {
                  ...item.character,
                  voice: {
                    ...item.character.voice,
                    text: action.payload.text,
                  }
                },
              }
            : item
        ),
      };
    case "UPDATE_VOICEOVER_MUTATION":
      return {
        ...state,
        items: state.items.map((item, i) =>
          i === action.payload.index
            ? {
                ...item,
                mutation: {
                  ...item.mutation,
                  voice: {
                    ...item.mutation.voice,
                    text: action.payload.text,
                  }
                },
              }
            : item
        ),
      };

    case "UPDATE_VOICEOVER":
      return {
        ...state,
        items: state.items.map((item, i) =>
          i === action.payload.index
            ? {
                ...item,
                voice: {
                  ...item.voice,
                  text: action.payload.text,
                },
              }
            : item
        ),
      };

      case "UPDATE_VOICEOVER_ANSWER":
        return {
          ...state,
          items: state.items.map((item, i) =>
            i === action.payload.index
              ? {
                  ...item,
                  answer: {
                    ...item.answer,
                    text: action.payload.text,
                  },
                }
              : item
          ),
        };

    case "UPDATE_INTRO_VOICEOVER":
      return {
        ...state,
        introvoice: {
          ...state.introvoice,
          text: action.payload.text,
        },
      };

    case "UPDATE_COMMENTS_VOICEOVER":
      return {
        ...state,
        commentsvoice: {
          ...state.commentsvoice,
          text: action.payload.text,
        },
      };

    case "UPDATE_EXPLAINER_VOICEOVER":
      return {
        ...state,
        explainervoice: {
          ...state.explainervoice,
          text: action.payload.text,
        },
      };
    
    case "UPDATE_SUBSCRIBE_VOICEOVER":
      return {
        ...state,
        subscribevoice: {
          ...state.subscribevoice,
          text: action.payload.text,
        },
      };
  
    case "UPDATE_ITEM_VOICE_FOR_KEY":
      return {
        ...state,
        items: state.items.map((item, i) =>
          i === action.payload.index
            ? {
                ...item,
                [action.payload.key]: {
                  ...item[action.payload.key],
                  voice: {
                    ...item[action.payload.key].voice,
                    voice: action.payload.voice
                  },
                },
              }
            : item
        ),
      };

    case "UPDATE_ITEM_VOICE":
      return {
        ...state,
        items: state.items.map((item, i) =>
          i === action.payload.index
            ? {
                ...item,
                voice: {
                  ...item.voice,
                  voice: action.payload.voice,
                },
              }
            : item
        ),
      };

    case "UPDATE_ITEM_VOICE_ANSWER":
      return {
        ...state,
        items: state.items.map((item, i) =>
          i === action.payload.index
            ? {
                ...item,
                answer: {
                  ...item.answer,
                  voice: action.payload.voice,
                },
              }
            : item
        ),
      };

    case "UPDATE_INTRO_VOICE":
      return {
        ...state,
        introvoice: {
          ...state.introvoice,
          voice: action.payload.voice,
        },
      };

    case "UPDATE_COMMENTS_VOICE":
      return {
        ...state,
        commentsvoice: {
          ...state.commentsvoice,
          voice: action.payload.voice,
        },
      };

    case "UPDATE_EXPLAINER_VOICE":
      return {
        ...state,
        explainervoice: {
          ...state.explainervoice,
          voice: action.payload.voice,
        },
      };

    case "UPDATE_SUBSCRIBE_VOICE":
      return {
        ...state,
        subscribevoice: {
          ...state.subscribevoice,
          voice: action.payload.voice,
        },
      };
  

    case "UPDATE_VIDEO":
      return {
        ...state,
        items: state.items.map((item, i) =>
          i === action.payload.index
            ? {
                ...item,
                [action.payload.optionKey]: {
                  ...item[action.payload.optionKey],
                  video: action.payload.filename,
                },
              }
            : item
        ),
      };

    default:
      return state;
  }
};

export default quizReducer;
